module.exports = __webpack_public_path__ + "img/certi-atp.21012051.jpg";